import { render, staticRenderFns } from "./AlignTopLeft.vue?vue&type=template&id=40f227d0&scoped=true&"
import script from "./AlignTopLeft.vue?vue&type=script&lang=js&"
export * from "./AlignTopLeft.vue?vue&type=script&lang=js&"
import style0 from "./AlignTopLeft.vue?vue&type=style&index=0&id=40f227d0&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40f227d0",
  null
  
)

export default component.exports